var _circle, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPpay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "url(#paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 29.1103L44.2969 25.2012C43.3974 16.4835 35.9944 9.70312 27 9.70312C18.0056 9.70312 10.6026 16.4835 9.70312 25.2012L27 29.1103Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0488 30.7705C10.291 31.9121 10.6715 33.0191 11.1558 34.0569L27.0344 35.0947L42.9129 34.0569C43.3972 33.0191 43.7431 31.9121 44.0199 30.7705L27.069 32.0851L10.0488 30.7705Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5244 42.083C21.0498 43.4668 23.921 44.297 26.9999 44.297C30.0787 44.297 32.9846 43.5014 35.4754 42.083H18.5244Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37.5859L12.8857 37.1016C13.6122 38.1394 14.4771 39.0734 15.4111 39.9037H38.5889C39.5229 39.0734 40.3878 38.1394 41.1142 37.1016L27 37.5859Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27,
    y1: 55.3289,
    x2: 27,
    y2: 5.28536e-7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A32CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE453D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpay);
export default __webpack_public_path__ + "static/media/ppay.95d93daf9e3f6c8dcbab230c840252a9.svg";
export { ForwardRef as ReactComponent };